import { render, staticRenderFns } from "./Uhistorytable.vue?vue&type=template&id=19660137&scoped=true"
import script from "./Uhistorytable.vue?vue&type=script&lang=js"
export * from "./Uhistorytable.vue?vue&type=script&lang=js"
import style0 from "./Uhistorytable.vue?vue&type=style&index=0&id=19660137&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19660137",
  null
  
)

export default component.exports